import React, { useMemo, useState } from 'react';
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import magnifyMemorial from '../images/stepperPics/magnify-memorial-brunette.png'
import compete from '../images/stepperPics/become-first.png'
import urbanExplorer from '../images/stepperPics/urbanExplorer.png'
import Skeleton from '@mui/material/Skeleton';
import {Flex} from "reflexbox";
import * as route from "../components/helpers/routes";
import { alpha, useTheme } from '@mui/material/styles';
import ResumeCourseDialog from "../components/ResumeCourseDialog";
import {useImageLoad} from "../helpers/helpers";

const TutorialStep = ({ step, index, activeStep, theme }) => {
  const { imgRef, loaded, onLoad, onError, showSkeleton } = useImageLoad(step.imgPath);

  if (Math.abs(activeStep - index) > 2) {
    return <div />;
  }

  return (
    <div>
      <Box position="relative" style={{ minHeight: 358 }}>
        {showSkeleton && (
          <>
            <Skeleton variant="rect" width="100%" height={364} />
            <Flex style={{ flexDirection: 'column', alignItems: 'center', padding: '20px 4px' }}>
              <Skeleton variant="text" width="75%"><Typography>.</Typography></Skeleton>
              <Skeleton variant="text" width="100%"><Typography>.</Typography></Skeleton>
              <Skeleton variant="text" width="75%"><Typography>.</Typography></Skeleton>
            </Flex>
          </>
        )}
        <img
          ref={imgRef}
          style={{
            height: 358,
            opacity: loaded ? 1 : 0,
            position: showSkeleton ? 'absolute' : 'static',
            top: showSkeleton ? 0 : undefined,
            left: showSkeleton ? 0 : undefined,
          }}
          src={step.imgPath}
          alt={step.label}
          onLoad={onLoad}
          onError={onError}
        />
      </Box>
      {loaded && (
        <>
          <Typography variant="h1">{step.title}</Typography>
          <Typography style={{
            padding: '20px 4px',
            minHeight: '96px',
            backgroundColor: theme.palette.background.default,
          }}>{step.label}</Typography>
        </>
      )}
    </div>
  );
};

const GameOverview = (props) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const tutorialSteps = [
    {
      title: 'Hi there, city explorer',
      label: props.specialName ? `Welcome ${props.specialName}!` : "Ready to unlock the secrets of the city?",
      imgPath: urbanExplorer,
    },
    {
      title: "Embark on a Journey",
      label: "Solve riddles, discover iconic monuments, and uncover rich histories behind iconic landmarks!",
      imgPath: magnifyMemorial,
    },
    {
      title: "Compete against friends",
      label: "Explore with a group or by yourself to get the highest score",
      imgPath: compete,
    },
  ];
  const viewingInGame = window.location.search.includes('true');
  const maxSteps = tutorialSteps.length;

  const handleStart = () => {
    if (viewingInGame) {
      navigate(-1);
    } else {
      navigate(route.HOME);
    }
  };
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const circles = useMemo(
    () =>
      Array.from({ length: maxSteps }, (_, i) => (
        <div
          key={i}
          onClick={() => setActiveStep(i)}
          style={{
            width: i === activeStep ? '30px' : '16px',
            height: '16px',
            borderRadius: '25px',
            backgroundColor:
              i === activeStep
                ? theme.palette.primary.main
                : alpha(theme.palette.text.primary, 0.26),
            margin: '5px',
          }}
        />
      )),
    [activeStep, maxSteps, theme]
  );

  return (
    <Flex style={{textAlign: 'center', flexDirection: 'column', justifyContent: 'space-between', height: '100%'}}>
      <div />
      <SwipeableViews
        axis="x"
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {tutorialSteps.map((step, index) => (
          <TutorialStep
            key={step.title}
            step={step}
            index={index}
            activeStep={activeStep}
            theme={theme}
          />
        ))}
      </SwipeableViews>

      <Flex style={{alignItems: 'center'}}>
        {
          <Flex style={{width: '100%', justifyContent: 'flex-start' }}><Button size="small" color="primary" style={{ minWidth: '99px', display: 'flex', justifyContent: 'flex-start', paddingLeft: '6px'}} variant="outlined"
                                                                               onClick={handleBack} disabled={activeStep === 0}  >
            <Flex><KeyboardArrowLeft/><Typography> Back </Typography> </Flex>
          </Button></Flex>
        }
        <Flex style={{width: "100%", justifyContent: 'center'}}>
        {circles}
        </Flex>
        {!(activeStep === maxSteps - 1) ? (
            <Flex style={{width: '100%', justifyContent: 'flex-end'}}><Button size="small" color="primary" style={{ minWidth: '99px'}} variant="outlined"
                                                                              onClick={handleNext} disabled={activeStep === maxSteps - 1} >
              <Flex style={{paddingLeft: '5px'}}><Typography> Next </Typography> <KeyboardArrowRight/> </Flex>
            </Button></Flex>)
          : (<Flex style={{width: '100%', justifyContent: 'flex-end'}}><Button variant="contained" color="primary" style={{width: 'min-content'}}
                                                                               onClick={handleStart}> {viewingInGame ? 'Return' : 'Continue'} </Button></Flex>)
        }
      </Flex>

      <Button color="primary" style={{marginBottom: '16px'}} onClick={handleStart}>{viewingInGame ? 'Return' : 'Skip'} </Button>
      {!viewingInGame && <ResumeCourseDialog/>}

    </Flex>
  )

};

export default GameOverview;
